<template>
    <div class="home">
        <div class="container">
            <div class="columns is-centered">
                <div class="column">
                    <div class="columns">
                        <ValidationObserver v-slot="{ errors }" tag="div">
                            <input-form
                            ref="form"
                            :errors="errors"
                            name="LeaseUpForm"
                            @submit.prevent="nextPage"
                            >
                                <div class="content">
                                    <br>
                                    <h1>Resident Income Certification (RIC) Form</h1>
                                    <callout type="info">
                                       <i>Please fill out this form for each household who will lease or is currently leasing an affordable unit created in compliance with the Mixed Income Housing program. 
                                        <b>For Initial Certifications, leases CANNOT be executed until the RIC is approved by Development Services staff.</b></i> 
                                    </callout>

                                    <h2>Project Information</h2>

                                    <div class="columns">
                                        <div class="column">
                                            <vee-dropdown
                                                id="certification"
                                                v-model="Certification"
                                                label="Select one of the following certifications"
                                                :options="certificationOptions"
                                                placeholder="Select one of the following certifications"
                                                required
                                                rules="required"
                                            />
                                        </div>
                                    </div>
                                    <div id="address">
                                        <h3>Project Address</h3>
                                        <div class="columns">
                                            <div class="column">
                                                <vee-textbox
                                                    id="txt-project-address-street1"
                                                    v-model="ProjectAddress.Street1"
                                                    mode="eager"
                                                    name="txt-project-address-street1"
                                                    placeholder="Street Address"
                                                    rules="required"
                                                    required
                                                    readonly
                                                    error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <textbox
                                                    v-model="ProjectAddress.Street2"
                                                    mode="eager"
                                                    readonly
                                                    name="txt-project-address-street2"
                                                    placeholder="Apt / Unit"
                                                />
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <vee-textbox
                                                    v-model="ProjectAddress.City"
                                                    mode="eager"
                                                    name="txt-project-address-city"
                                                    placeholder="City"
                                                    :disabled="true"
                                                    readonly
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-textbox
                                                    v-model="ProjectAddress.State"
                                                    mode="eager"
                                                    name="txt-project-address-state"
                                                    placeholder="State"
                                                    :disabled="true"
                                                    readonly
                                                />
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <vee-textbox
                                                    id="txt-project-address-zip"
                                                    v-model="ProjectAddress.Zip"
                                                    mode="eager"
                                                    name="txt-project-address-zip"
                                                    placeholder="ZIP Code"
                                                    rules="required"
                                                    required
                                                    error="This field is required"
                                                    :disabled="true"
                                                    readonly
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-textbox
                                                    v-model="ProjectAddress.Country"
                                                    label="Country"
                                                    :disabled="true"
                                                    readonly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="columns" style="margin-left: 0.5%;">
                                        <div class="column">
                                            <h3>Standard Lease Form <i style="color: #cc3000;">(required)</i></h3>
                                                <file-upload
                                                    ref="upload"
                                                    v-model="LeaseForm"
                                                    :input-id="`file-lease-form`"
                                                    extensions="gif,jpg,jpeg,png,webp,pdf"
                                                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                    label="File"
                                                    @input-filter="inputFilter"
                                                    >
                                                    <button class="button is-primary" style="margin-bottom: 1%;">
                                                    <i class="fa fa-plus"></i>
                                                    &nbsp; Select File to Upload
                                                    </button>
                                            </file-upload>
                                            <li v-for="file in LeaseForm" :key="file.id">
                                                <span>{{ file.name }} - </span>
                                                <!-- <span
                                                    v-if="file.error"
                                                    class="is-love-park-red"
                                                >
                                                    Something went wrong - {{ file.errorMessage }}
                                                </span>

                                                <span
                                                    v-else-if="file.success"
                                                    class="is-phanatic-green"
                                                >
                                                    Upload Successful.
                                                </span>
                                                <span
                                                    v-else-if="file.uploading"
                                                    class="is-flyers-orange"
                                                >
                                                    Uploading Document...</span> -->
                                                </li>
                                        </div>
                                        <div class="column">
                                        <h3>Tenant Acknowledgement Certificate <i style="color: #cc3000;">(required)</i></h3>
                                            <file-upload
                                                ref="upload"
                                                v-model="AcknowledgementCert"
                                                :input-id="`file-acknowledgement-cert`"
                                                extensions="gif,jpg,jpeg,png,webp,pdf"
                                                accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                label="File"
                                                @input-filter="inputFilter"
                                                >
                                                <button class="button is-primary" style="margin-bottom: 1%;">
                                                <i class="fa fa-plus"></i>
                                                &nbsp; Select File to Upload
                                                </button>
                                        </file-upload>
                                        <li v-for="file in AcknowledgementCert" :key="file.id">
                                            <span>{{ file.name }} - </span>
                                            <!-- <span
                                                v-if="file.error"
                                                class="is-love-park-red"
                                            >
                                                Something went wrong - {{ file.errorMessage }}
                                            </span>

                                            <span
                                                v-else-if="file.success"
                                                class="is-phanatic-green"
                                            >
                                                Upload Successful.
                                            </span>
                                            <span
                                                v-else-if="file.uploading"
                                                class="is-flyers-orange"
                                            >
                                                Uploading Document...</span> -->
                                            </li>
                                        </div>
                                        </div>

                                    <h2>Unit Information</h2>
                                    
                                    <div class="columns">
                                        <div class="column">
                                            <vee-textbox
                                                id="unit-type"
                                                v-model="NumOfBedrooms"
                                                label="Unit Type"
                                                placeholder="Unit Type"
                                                required
                                                :disabled="true"
                                                readonly
                                                rules="required"
                                            />
                                        </div>
                                        <div class="column">
                                            <vee-textbox
                                                id="unit-occupation-date"
                                                v-model="UnitOccupationDate"
                                                label="Unit Occupation Date"
                                                placeholder="Unit Occupation Date"
                                                required
                                                rules="required"
                                                :disabled="true"
                                                readonly
                                                type="date"
                                            />
                                        </div>
                                    </div>
                                    
                                    <div class="columns">
                                        <div class="column">
                                            <label><b>Based on the affordability restrictions stated in the deed restriction for the unit, indicate the income limit expressed as a percentage of Area Median Income (AMI)</b></label>
                                            <vee-textbox
                                                id="affordability-restrictions"
                                                v-model="AffordabilityRestrictions"
                                                placeholder="% AMI"
                                                required
                                                rules="required|numericAMI"
                                                :disabled="true"
                                                readonly
                                                type="number"
                                            />
                                        </div>
                                    </div>

                                    <div class="columns">
                                        <div class="column">
                                            <vee-dropdown
                                                id="section-8-voucher"
                                                v-model="Section8Voucher"
                                                label="Will the household be using a Section 8 Housing Choice Voucher?"
                                                :options="yesNo"
                                                placeholder="Will the household be using a Section 8 Housing Choice Voucher?"
                                                required
                                                rules="required"
                                                @change="onNo"
                                            />
                                        </div>
                                    </div>

                                    <div v-if="Section8Voucher == 'No'">
                                        <!-- <div style="margin-left: 1%;">
                                            <h3>Completed Utility Allowance Schedule <i style="color: #cc3000;">(required)</i></h3>
                                            <file-upload
                                                ref="upload"
                                                v-model="UtilityAllowanceSchedule"
                                                :input-id="`file-utility-allowance-schedule`"
                                                extensions="gif,jpg,jpeg,png,webp,pdf"
                                                accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                label="File"
                                                @input-filter="inputFilter"
                                                >
                                                <button class="button is-primary" style="margin-bottom: 1%;">
                                                <i class="fa fa-plus"></i>
                                                &nbsp; Select File to Upload
                                                </button>
                                        </file-upload>
                                        <li v-for="file in UtilityAllowanceSchedule" :key="file.id">
                                            <span>{{ file.name }} - </span>
                                            <span
                                                v-if="file.error"
                                                class="is-love-park-red"
                                            >
                                                Something went wrong - {{ file.errorMessage }}
                                            </span>

                                            <span
                                                v-else-if="file.success"
                                                class="is-phanatic-green"
                                            >
                                                Upload Successful.
                                            </span>
                                            <span
                                                v-else-if="file.uploading"
                                                class="is-flyers-orange"
                                            >
                                                Uploading Document...</span>
                                            </li>
                                        </div> -->
                                        <br>
                                        <div class="columns">
                                            <div class="column">
                                                <vee-radio
                                                v-model="TenantGas"
                                                :options="yesNoNA"
                                                label="Is the tenant responsible for paying for gas?"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-radio
                                                v-model="TenantElectric"
                                                :options="yesNo"
                                                label="Is the tenant responsible for paying for electric?"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-radio
                                                v-model="TenantWater"
                                                :options="yesNo"
                                                label="Is the tenant responsible for Water?"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-radio
                                                v-model="TenantSewer"
                                                :options="yesNo"
                                                label="Is the tenant responsible for Sewer?"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                        </div>
                                        <div v-if="TenantGas == 'Yes' && TenantElectric == 'Yes'" class="columns" style="margin-left: 10%;">
                                            <div class="column">
                                                <vee-radio
                                                v-model="HeatingPower"
                                                :options="gasElectric"
                                                label="How is heating powered?"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-radio
                                                v-model="StovePower"
                                                :options="gasElectric"
                                                label="How is the stove powered?"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-radio
                                                v-model="WaterHeatingPower"
                                                :options="gasElectric"
                                                label="How is Water Heating powered?"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                        </div>
                                        <table v-if="UtilityAllowanceItems.length > 0" class="utility-allowance" style="border-width: 2px; border-style: solid; width: 70%; margin-left: 13%;">
                                            <tr style="background-color: #2176d2; color: white;">
                                                <td>Utility or Service</td>
                                                <td>per month cost</td>
                                            </tr>
                                            <tr
                                            v-for="item in UtilityAllowanceItems"
                                            :key="item.name"
                                            :class="`utility-item-${item.name}`"
                                            >
                                                <td v-if="item.name == 'Total'" style="background-color: #fff7d0; border-right-width: 2px;"><b>{{ item.name }}</b></td>
                                                <td v-else style="border-right-width: 2px;">{{ item.name }}</td>
                                                <td v-if="item.name == 'Total'" style="background-color: #fff7d0;"><b>{{ item.cost.toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</b></td>
                                                <td v-else>{{ item.cost.toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</td>
                                            </tr>
                                        </table>
                                        <div style="border-width: 2px; border-style: solid; width: 70%; margin-left: 13%; padding: 0.5%;">
                                            <div class="columns">
                                                <div class="column">
                                                    <p><b> Rent Limit:</b> {{ grossRentLimit.toLocaleString("en-US", {style: "currency", currency: "USD"}) }} per month</p>
                                                </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <p><b>Utility Allowance:</b> {{ UtilityAllowance.toLocaleString("en-US", {style: "currency", currency: "USD"}) }} per month</p>
                                                </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <p><b>Maximum Monthly Rent Charged to Tenant:</b> {{ (grossRentLimit - UtilityAllowance) > 0 ? (grossRentLimit - UtilityAllowance).toLocaleString("en-US", {style: "currency", currency: "USD"}) : 0 }} per month</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="Section8Voucher == 'Yes'">
                                        <div style="margin-left: 1%;">
                                            <h3>Proof of Section 8 Housing Choice Voucher <i style="color: #cc3000;">(required)</i></h3>
                                            <file-upload
                                                ref="upload"
                                                v-model="ProofOfSection8"
                                                :input-id="`file-proof-of-section-8`"
                                                extensions="gif,jpg,jpeg,png,webp,pdf"
                                                accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                label="File"
                                                @input-filter="inputFilter"
                                                >
                                                <button class="button is-primary" style="margin-bottom: 1%;">
                                                <i class="fa fa-plus"></i>
                                                &nbsp; Select File to Upload
                                                </button>
                                        </file-upload>
                                        <li v-for="file in ProofOfSection8" :key="file.id">
                                            <span>{{ file.name }} - </span>
                                            <!-- <span
                                                v-if="file.error"
                                                class="is-love-park-red"
                                            >
                                                Something went wrong - {{ file.errorMessage }}
                                            </span>

                                            <span
                                                v-else-if="file.success"
                                                class="is-phanatic-green"
                                            >
                                                Upload Successful.
                                            </span>
                                            <span
                                                v-else-if="file.uploading"
                                                class="is-flyers-orange"
                                            >
                                                Uploading Document...</span> -->
                                            </li>
                                        </div>
                                    </div>
                                

                                        <!-- <h2>Household Composition</h2>
                                        <br>
                                        <h6>Please fill out the chart below with the names and birth dates of all adults living in the unit. Note: All adults must appear on the lease, except for the legal dependents of leaseholders as claimed on the most recent federal income tax return or legal minor children of leaseholders.</h6>
                                        <br>
                                     <div class="field-container tenant-information">
                                        <div
                                        v-for="tenant in TenantList"
                                        :key="tenant.id"
                                        :class="`tenant-contact-information-${tenant.id}`"
                                        >
                                        <div>
                                            <div v-if="tenant.id > 1">
                                            </div>
                                            <h3>Adult (18 and Over) - {{ tenant.id }}</h3>
                                            <div
                                            class="columns"
                                            >
                                            <div class="column">
                                                <vee-textbox
                                                v-model="tenant.FirstName"
                                                mode="eager"
                                                :name="`txt-tenant-${tenant.id}-first-name`"
                                                placeholder="First Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-textbox
                                                v-model="tenant.LastName"
                                                mode="eager"
                                                :name="`txt-tenant-${tenant.id}-last-name`"
                                                placeholder="Last Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                <vee-dropdown
                                                v-model="tenant.Race"
                                                :name="`dropdown-tenant-${tenant.id}-race`"
                                                label="Race"
                                                :options="MultipleChoiceFieldOptions.Race"
                                                rules="required"
                                                required
                                                placeholder="Race"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-dropdown
                                                v-model="tenant.Ethnicity"
                                                :name="`dropdown-tenant-${tenant.id}-ethnicity`"
                                                label="Race"
                                                :options="MultipleChoiceFieldOptions.Ethnicity"
                                                rules="required"
                                                required
                                                placeholder="Ethnicity"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-textbox
                                                v-model="tenant.DateOfBirth"
                                                :name="`text-tenant-${tenant.id}-date-of-birth`"
                                                label="Date of Birth"
                                                rules="required"
                                                required
                                                placeholder="Date of Birth"
                                                type="date"
                                                />
                                            </div>
                                            </div>
                                            <button
                                                type="button"
                                                class="button is-danger"
                                                @click="removeTenant(tenant.id)"
                                            >
                                                Remove Adult {{ tenant.id }}
                                            </button>

                                            </div>
                                        </div>
                                        <br>
                                            <button
                                                type="button"
                                                class="button is-success"
                                                @click="addTenant(TenantList.length)"
                                            >
                                                Add Adult
                                            </button>
                                        </div>

                                    <br>
                                    <h6>Please fill out the chart below with the names and birth dates of any individuals living in the unit who are not listed on lease:</h6>

                                    <div class="field-container child-information">
                                        <div
                                        v-for="child in ChildList"
                                        :key="child.id"
                                        :class="`child-contact-information-${child.id}`"
                                        >
                                        <div>
                                            <div v-if="child.id > 1">
                                            </div>
                                            <h3>Child (under 18) - {{ child.id }}</h3>
                                            <div
                                            class="columns"
                                            >
                                            <div class="column">
                                                <vee-textbox
                                                v-model="child.FirstName"
                                                mode="eager"
                                                :name="`txt-child-${child.id}-first-name`"
                                                placeholder="First Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-textbox
                                                v-model="child.LastName"
                                                mode="eager"
                                                :name="`txt-child-${child.id}-last-name`"
                                                placeholder="Last Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            </div>
                                            <div class="columns">
                                            <div class="column">
                                                <vee-textbox
                                                v-model="child.DateOfBirth"
                                                :name="`text-child-${child.id}-date-of-birth`"
                                                label="Date of Birth"
                                                rules="required"
                                                required
                                                placeholder="Date of Birth"
                                                type="date"
                                                />
                                            </div>
                                            </div>
                                            <button
                                                type="button"
                                                class="button is-danger"
                                                @click="removeChild(child.id)"
                                            >
                                                Remove Child {{ child.id }}
                                            </button>
                                            <br>

                                            </div>
                                        </div>
                                        <div v-if="ChildList.length >= 1">
                                            <br>
                                        </div>
                                            <button
                                                type="button"
                                                class="button is-success"
                                                @click="addChild(ChildList.length)"
                                            >
                                                Add Child
                                            </button>
                                        </div>
                                        <br>
                                        <div class="columns">
                                            <div class="column">
                                                <p>Total household size including all individuals who reside in the unit: <b>{{ TenantList.length + ChildList.length }}</b></p>
                                            </div>
                                        </div>
                                    <h2>Annual Household Income</h2>
                                    <div class="field-container income-information">
                                        <div
                                        v-for="income in IncomeList"
                                        :key="income.id"
                                        :class="`income-information-${income.id}`"
                                        >
                                        <div>
                                            <div v-if="income.id > 1">
                                            </div>
                                            <h3>Income Source - {{ income.id }}</h3>
                                            <div
                                            class="columns"
                                            >
                                            <div class="column">
                                                <vee-textbox
                                                v-model="income.FirstName"
                                                mode="eager"
                                                :name="`txt-income-${income.id}-first-name`"
                                                placeholder="First Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-textbox
                                                v-model="income.LastName"
                                                mode="eager"
                                                :name="`txt-income-${income.id}-last-name`"
                                                placeholder="Last Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <vee-dropdown
                                                    v-model="income.IncomeType"
                                                    mode="eager"
                                                    :id="`txt-income-type-${income.id}`"
                                                    :name="`txt-income-type-${income.id}`"
                                                    placeholder="Type Of Income"
                                                    :options="incomeType"
                                                    required
                                                    rules="required"
                                                    error="This field is required"
                                                    @change="totalIncome(income)"
                                                    />
                                                </div>
                                                <div class="column">
                                                    <vee-textbox
                                                    v-model="income.Income"
                                                    mode="eager"
                                                    :name="`txt-income-${income.id}`"
                                                    placeholder="Estimated Annual Income"
                                                    required
                                                    rules="doubleCurrency|required"
                                                    error="This field is required"
                                                    type="number"
                                                    @change="totalIncome(income)"
                                                    />
                                                </div>
                                            </div>
                                            
                                            <button
                                                type="button"
                                                class="button is-danger"
                                                @click="removeIncome(income.id)"
                                            >
                                                Remove Income Source {{ income.id }}
                                            </button>
                                            <br>
                                            </div>
                                        </div>
                                        <br>
                                            <button
                                                type="button"
                                                class="button is-success"
                                                @click="addIncome(IncomeList.length)"
                                            >
                                                Add Income Source
                                            </button>
                                        </div>
                                        <br>
                                        <div class="field-container tax-information">
                                        <div
                                        v-for="taxes in TaxesList"
                                        :key="taxes.id"
                                        :class="`tax-information-${taxes.id}`"
                                        >
                                        <div>
                                            <div v-if="taxes.id > 1">
                                            </div>
                                            <h3>Gross Taxes - {{ taxes.id }}</h3>
                                            <div
                                            class="columns"
                                            >
                                            <div class="column">
                                                <vee-textbox
                                                v-model="taxes.FirstName"
                                                mode="eager"
                                                :name="`txt-tax-${taxes.id}-first-name`"
                                                placeholder="First Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-textbox
                                                v-model="taxes.LastName"
                                                mode="eager"
                                                :name="`txt-tax-${taxes.id}-last-name`"
                                                placeholder="Last Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <vee-textbox
                                                    v-model="taxes.GrossAmount"
                                                    mode="eager"
                                                    :name="`txt-taxes-${taxes.id}`"
                                                    placeholder="Gross Amount"
                                                    required
                                                    rules="doubleCurrency|required"
                                                    error="This field is required"
                                                    type="number"
                                                    @change="totalGrossTaxes(taxes)"
                                                    />
                                                </div>
                                            </div>
                                            
                                            <button
                                                type="button"
                                                class="button is-danger"
                                                @click="removeTaxes(taxes.id)"
                                            >
                                                Remove Gross Tax Amount {{ taxes.id }}
                                            </button>
                                            <br>
                                            </div>
                                        </div>
                                        <div v-if="TaxesList.length >= 1">
                                            <br>
                                        </div>
                                            <button
                                                type="button"
                                                class="button is-success"
                                                @click="addTaxes(TaxesList.length)"
                                            >
                                                Add Gross Tax Amount
                                            </button>
                                        </div>
                                         <ul>
                                            <li>¹Gross amount of wages include salaries, overtime pay, commissions, fees tips, and bonuses. Annual income is calculated by taking the average of paystubs and multiplying by 26 if biweekly or 52 if weekly.</li>
                                            <li>²Social Security, SSI, Pensions, etc.</li>
                                            <li>³Employment Income + Payments in lieu + Public Assistance + child Income</li>
                                        </ul>
                                        <br>
                                        <div class="columns">
                                            <div class="column">
                                                <h4>Use the Income Calculation that yields the highest number for each income earning adult to calculate the total Annual Household Income, and indicate here: <u>${{ Number(totalHouseholdIncome).toFixed(2) }}</u></h4>
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <h4>Total Monthly Household Income:  <u>${{ (Number(totalHouseholdIncome)/12).toFixed(2) }}</u></h4>
                                            </div>
                                        </div> -->
                                
                                    </div>
                                <template #submit>
                                    <div class="actions columns">
                                    <div class="column is-2 is-offset-10">
                                        <button
                                        type="button"
                                        class="button is-primary"
                                        @click="nextPage"
                                        :disabled="(LeaseForm.length < 1 || AcknowledgementCert.length < 1) || (Section8Voucher == 'Yes' && (ProofOfSection8.length < 1))"
                                        >
                                        Next
                                        </button>
                                    </div>
                                    </div>
                                    <!-- <div class="column">
                                    <div v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
                                        Submitting...
                                    </div>
                                    <div v-if="SubmitStatus.Value === SubmitStatus.Options.OK">
                                        OK
                                    </div>
                                    <div v-if="SubmitStatus.Value === SubmitStatus.Options.ERROR">
                                        Error
                                    </div>
                                    </div> -->
                                </template>
                            </input-form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import FileUpload from "vue-upload-component";
import options from "@/utilities/options";
import buildAffordableUnitObject from "@/utilities/get-affordable-unit";
import axios from "axios";
import { getPropertyValueOrDefault } from "@/utilities/functions.js";

export default {
  name: 'LeaseUpForm',
  components: { FileUpload },
  mixins: [options],
  props: {
    recordId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
        Certification: null,
        ProjectAddress: {
            Street1: null,
            Street2: null,
            City: "Philadelphia",
            State: "Pennsylvania",
            Zip: null,
            Country: "United States",
        },
        NumOfBedrooms: null,
        UnitOccupationDate: null,
        AffordabilityRestrictions: null,
        Section8Voucher: null,
        TenantGas: null,
        TenantElectric: null,
        TenantWater: null,
        TenantSewer: null,
        MonthlyFee: null,
        HeatingPower: null,
        StovePower: null,
        WaterHeatingPower: null,
        TenantList: [],
        ChildList: [],
        UtilityAllowanceItems: [],
        UtilityAllowanceTotal: null,
        RentCharged: null,
        GrossRentLimit: null,
        LeaseForm: [],
        AcknowledgementCert: [],
        UtilityAllowanceSchedule: [],
        ProofOfSection8: [],
        RelatedUnit: null,
    };
  },
  async created(){
        window.scrollTo(0, 0);
        if(await this.$vlf.getItem('fullApplication') != null){
            Object.assign(this.$data, await this.$vlf.getItem('fullApplication'));
        }
        //var cognitoSub = this.$store.getters["auth/userInfo"].sub;
        var vData = this;
       const dataObject = buildAffordableUnitObject(
          this.recordId,
          "SHARC_GET_AFFORDABLE_UNIT"
        );
        const requestObj = {
          table: "bub4bywng",
          data: dataObject
        };
        console.log(requestObj);
        axios
          .post(
            "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy-Reads",
            requestObj
          ).then(response => {
            console.log(response);
            const responseObject = getPropertyValueOrDefault(["data", "record", "f"], response);
            vData.ProjectAddress.Street1 = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "17"));
            vData.ProjectAddress.Street2 = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "6"));
            vData.ProjectAddress.City = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "19"));
            vData.ProjectAddress.State = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "20"));
            vData.ProjectAddress.Zip = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "21"));
            vData.NumOfBedrooms = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "7"));
            vData.AffordabilityRestrictions = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "10"));
            vData.AffordabilityRestrictions = vData.AffordabilityRestrictions.replace(vData.AffordabilityRestrictions.substring(vData.AffordabilityRestrictions.length-1), "");
            vData.UnitOccupationDate = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "22"));
            vData.RelatedUnit = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "12"));
          })     
    },
  methods:{
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?|exe?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    onNo(){
        if(this.Section8Voucher == "Yes"){
            this.TenantGas = null;
            this.TenantElectric = null;
            this.TenantWater = null;
            this.TenantSewer = null;
            this.HeatingPower = null;
            this.StovePower = null;
            this.WaterHeatingPower = null;
            this.UtilityAllowanceItems = [];
            this.UtilityAllowanceSchedule = [];
        }
        else{
            this.ProofOfSection8 = [];
        }
    },
    async nextPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.RentCharged = this.GrossRentLimit - this.UtilityAllowanceTotal;
            await this.$vlf.setItem('fullApplication', this.$data);
            
            this.$router.push({
                name: "TenantIncome",
                params: { tenantId: 1 },
            });
        }
    },
    UtilityAllowanceGasOnly(){
        var vData = this;
            this.UtilityAllowanceItems.push({name: "Gas Charge", cost: 16});
            
                switch(vData.NumOfBedrooms){
                    case 'Studio':
                        this.UtilityAllowanceItems.push({name: "Heating", cost: 31});
                        this.UtilityAllowanceItems.push({name: "Cooking", cost: 5});
                        this.UtilityAllowanceItems.push({name: "Water Heating", cost: 9});
                        break;
                    case '1 bedroom':
                        this.UtilityAllowanceItems.push({name: "Heating", cost: 35});
                        this.UtilityAllowanceItems.push({name: "Cooking", cost: 5});
                        this.UtilityAllowanceItems.push({name: "Water Heating", cost: 12});
                        break;
                    case '2 bedrooms':
                        this.UtilityAllowanceItems.push({name: "Heating", cost: 41});
                        this.UtilityAllowanceItems.push({name: "Cooking", cost: 8});
                        this.UtilityAllowanceItems.push({name: "Water Heating", cost: 17});
                        break;
                    case '3 bedrooms':
                        this.UtilityAllowanceItems.push({name: "Heating", cost: 46});
                        this.UtilityAllowanceItems.push({name: "Cooking", cost: 9});
                        this.UtilityAllowanceItems.push({name: "Water Heating", cost: 21});
                        break;
                }

    },
    UtilityAllowanceElectricOnly(){
        var vData = this;
        
            this.UtilityAllowanceItems.push({name: "Electric Charge", cost: 11});
            switch(vData.NumOfBedrooms){
                case 'Studio':
                    this.UtilityAllowanceItems.push({name: "Other Electric (Lights & Appliances)", cost: 29});
                    this.UtilityAllowanceItems.push({name: "Air Conditioning", cost: 11});
                    this.UtilityAllowanceItems.push({name: "Heating", cost: 26});
                    this.UtilityAllowanceItems.push({name: "Cooking", cost: 8});
                    this.UtilityAllowanceItems.push({name: "Water Heating", cost: 19});
                    break;
                case '1 bedroom':
                    this.UtilityAllowanceItems.push({name: "Other Electric (Lights & Appliances)", cost: 35});
                    this.UtilityAllowanceItems.push({name: "Air Conditioning", cost: 13});
                    this.UtilityAllowanceItems.push({name: "Heating", cost: 30});
                    this.UtilityAllowanceItems.push({name: "Cooking", cost: 9});
                    this.UtilityAllowanceItems.push({name: "Water Heating", cost: 23});
                    break;
                case '2 bedrooms':
                    this.UtilityAllowanceItems.push({name: "Other Electric (Lights & Appliances)", cost: 48});
                    this.UtilityAllowanceItems.push({name: "Air Conditioning", cost: 18});
                    this.UtilityAllowanceItems.push({name: "Heating", cost: 40});
                    this.UtilityAllowanceItems.push({name: "Cooking", cost: 13});
                    this.UtilityAllowanceItems.push({name: "Water Heating", cost: 29});
                    break;
                case '3 bedrooms':
                    this.UtilityAllowanceItems.push({name: "Other Electric (Lights & Appliances)", cost: 62});
                    this.UtilityAllowanceItems.push({name: "Air Conditioning", cost: 23});
                    this.UtilityAllowanceItems.push({name: "Heating", cost: 50});
                    this.UtilityAllowanceItems.push({name: "Cooking", cost: 17});
                    this.UtilityAllowanceItems.push({name: "Water Heating", cost: 35});
                    break;
        }
    },
    UtilityAllowanceGasAndElectric(){
        var vData = this;

        this.UtilityAllowanceItems.push({name: "Electric Charge", cost: 11});
        this.UtilityAllowanceItems.push({name: "Gas Charge", cost: 16});

        if(vData.NumOfBedrooms == 'Studio'){
            this.UtilityAllowanceItems.push({name: "Other Electric (Lights & Appliances)", cost: 29});
            this.UtilityAllowanceItems.push({name: "Air Conditioning", cost: 11});
            if(vData.HeatingPower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Heating", cost: 31});
            }
            else if(vData.HeatingPower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Heating", cost: 26});
            }
            if(vData.StovePower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Cooking", cost: 5});
            }
            else if(vData.StovePower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Cooking", cost: 8});
            }
            if(vData.WaterHeatingPower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Water Heating", cost: 9});
            }
            else if(vData.WaterHeatingPower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Water Heating", cost: 19});
            }
        }
        else if(vData.NumOfBedrooms == '1 bedroom'){
            this.UtilityAllowanceItems.push({name: "Other Electric (Lights & Appliances)", cost: 35});
            this.UtilityAllowanceItems.push({name: "Air Conditioning", cost: 13});
            if(vData.HeatingPower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Heating", cost: 16});
            }
            else if(vData.HeatingPower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Heating", cost: 30});
            }
            if(vData.StovePower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Cooking", cost: 5});
            }
            else if(vData.StovePower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Cooking", cost: 9});
            }
            if(vData.WaterHeatingPower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Water Heating", cost: 12});
            }
            else if(vData.WaterHeatingPower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Water Heating", cost: 23});
            }
        }
        else if(vData.NumOfBedrooms == '2 bedrooms'){
            this.UtilityAllowanceItems.push({name: "Other Electric (Lights & Appliances)", cost: 48});
            this.UtilityAllowanceItems.push({name: "Air Conditioning", cost: 18});
            if(vData.HeatingPower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Heating", cost: 41});
            }
            else if(vData.HeatingPower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Heating", cost: 40});
            }
            if(vData.StovePower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Cooking", cost: 8});
            }
            else if(vData.StovePower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Cooking", cost: 13});
            }
            if(vData.WaterHeatingPower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Water Heating", cost: 17});
            }
            else if(vData.WaterHeatingPower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Water Heating", cost: 16});
            }
        }
        else if(vData.NumOfBedrooms == '3 bedrooms'){
            this.UtilityAllowanceItems.push({name: "Other Electric (Lights & Appliances)", cost: 62});
            this.UtilityAllowanceItems.push({name: "Air Conditioning", cost: 23});
            if(vData.HeatingPower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Heating", cost: 46});
            }
            else if(vData.HeatingPower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Heating", cost: 50});
            }
            if(vData.StovePower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Cooking", cost: 9});
            }
            else if(vData.StovePower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Cooking", cost: 17});
            }
            if(vData.WaterHeatingPower == 'Gas'){
                this.UtilityAllowanceItems.push({name: "Water Heating", cost: 21});
            }
            else if(vData.WaterHeatingPower == 'Electric'){
                this.UtilityAllowanceItems.push({name: "Water Heating", cost: 35});
            }
        }
    },
     UtilityAllowanceWater(){
        var vData = this;
        switch(vData.NumOfBedrooms){
                case 'Studio':
                    this.UtilityAllowanceItems.push({name: "Water", cost: 29});
                    break;
                case '1 bedroom':
                    this.UtilityAllowanceItems.push({name: "Water", cost: 30});
                    break;
                case '2 bedrooms':
                    this.UtilityAllowanceItems.push({name: "Water", cost: 40});
                    break;
                case '3 bedrooms':
                    this.UtilityAllowanceItems.push({name: "Water", cost: 50});
                    break;
            }
  },
    UtilityAllowanceSewer(){
        var vData = this;

        switch(vData.NumOfBedrooms){
            case 'Studio':
                this.UtilityAllowanceItems.push({name: "Sewer", cost: 43});
                break;
            case '1 bedroom':
                this.UtilityAllowanceItems.push({name: "Sewer", cost: 44});
                break;
            case '2 bedrooms':
                this.UtilityAllowanceItems.push({name: "Sewer", cost: 51});
                break;
            case '3 bedrooms':
                this.UtilityAllowanceItems.push({name: "Sewer", cost: 58});
                break;
        }

    },
    fixUtilityItems(){
        this.UtilityAllowanceTotal = 0;
        this.GrossRentLimit = 0;

        if(this.UtilityAllowanceItems.length > 0){

            this.UtilityAllowanceTotal = this.UtilityAllowanceItems.map(e => e.cost).reduce((a,b) => a + b);
            this.UtilityAllowanceItems.push({name: "Total", cost: this.UtilityAllowanceTotal});
        }

        this.GrossRentLimit = this.grossRentLimit;

        return this.UtilityAllowanceTotal;
    },
    resetUtilityAllowanceItems(){
        this.UtilityAllowanceItems = [];
    },
  },
  computed:{
    UtilityAllowance: function(){
        var vData = this;
        this.resetUtilityAllowanceItems();

        if(vData.TenantElectric == "Yes" && (vData.TenantGas == "No" || vData.TenantGas == "N/A"))
        {
           vData.UtilityAllowanceElectricOnly();
        }
        else if(vData.TenantElectric == "No" && vData.TenantGas == "Yes")
        {
            vData.UtilityAllowanceGasOnly();
        }
        else if(vData.TenantElectric == "Yes" && vData.TenantGas == "Yes"){
            vData.UtilityAllowanceGasAndElectric();
        }

        if(vData.TenantWater == "Yes"){
            vData.UtilityAllowanceWater();
        }
        if(vData.TenantSewer == "Yes"){
            vData.UtilityAllowanceSewer();
        }

        var totalUtilityAllowance = vData.fixUtilityItems();

        return totalUtilityAllowance;
    },
    grossRentLimit: function() {
        if(this.AffordabilityRestrictions == null || this.AffordabilityRestrictions == ""){
            return 0;
        }
        if(this.AffordabilityRestrictions <= 40){
            if(this.NumOfBedrooms == "Studio"){
                return 803;
            }
            if(this.NumOfBedrooms == "1 bedroom"){
                return 860;
            }
            if(this.NumOfBedrooms == "2 bedrooms"){
                return 1032;
            }
            if(this.NumOfBedrooms == "3 bedrooms"){
                return 1193;
            }
        }
        if(this.AffordabilityRestrictions <= 50){
            if(this.NumOfBedrooms == "Studio"){
                return 1003;
            }
            if(this.NumOfBedrooms == "1 bedroom"){
                return 1075;
            }
            if(this.NumOfBedrooms == "2 bedrooms"){
                return 1290;
            }
            if(this.NumOfBedrooms == "3 bedrooms"){
                return 1491;
            }
        }
        if(this.AffordabilityRestrictions <= 60){
            if(this.NumOfBedrooms == "Studio"){
                return 1204;
            }
            if(this.NumOfBedrooms == "1 bedroom"){
                return 1290;
            }
            if(this.NumOfBedrooms == "2 bedrooms"){
                return 1548;
            }
            if(this.NumOfBedrooms == "3 bedrooms"){
                return 1789;
            }
        }
        if(this.AffordabilityRestrictions <= 80){
            if(this.NumOfBedrooms == "Studio"){
                return 1606;
            }
            if(this.NumOfBedrooms == "1 bedroom"){
                return 1721;
            }
            if(this.NumOfBedrooms == "2 bedrooms"){
                return 2064;
            }
            if(this.NumOfBedrooms == "3 bedrooms"){
                return 2386;
            }
        }
        if(this.AffordabilityRestrictions <= 100){
            if(this.NumOfBedrooms == "Studio"){
                return 2007;
            }
            if(this.NumOfBedrooms == "1 bedroom"){
                return 2151;
            }
            if(this.NumOfBedrooms == "2 bedrooms"){
                return 2580;
            }
            if(this.NumOfBedrooms == "3 bedrooms"){
                return 2982;
            }
        }
        if(this.AffordabilityRestrictions <= 120 || this.AffordabilityRestrictions > 120){
            if(this.NumOfBedrooms == "Studio"){
                return 2409;
            }
            if(this.NumOfBedrooms == "1 bedroom"){
                return 2581;
            }
            if(this.NumOfBedrooms == "2 bedrooms"){
                return 3096;
            }
            if(this.NumOfBedrooms == "3 bedrooms"){
                return 3579;
            }
        }
        return 0;
    },
  },
};
</script>

<style>
.field-container{
    border-style: double;
    padding: 1%;
    color: gray;
    border-width: 5px;
    border-radius: 10px;
}
</style>